import { useLocation } from "react-router-dom";
import { useApiInfiniteQuery } from "../../../services/api";
import { useFirebaseUser } from "./useFirebaseUser";

const limit = 10;

export function useGetUserCreatedPlaylistsQuery() {
  const { firebaseUser } = useFirebaseUser();
  const location = useLocation();
  const enabled =
    firebaseUser !== null &&
    !location.pathname.startsWith("/login") &&
    !location.pathname.startsWith("/signup");

  const query = useApiInfiniteQuery(
    "/webapp/private/playlists/me",
    enabled ? { query: { limit }, durable: true } : false
  );

  const playlists = query.state === "success" ? query.docs : [];
  const playlistIds = playlists.map((playlist) => playlist.id).join(",");
  const savedArticlesIds = [
    ...new Set(playlists.flatMap((playlist) => playlist.playlist)),
  ];
  const savedContentIds = [
    ...new Set(playlists.flatMap((playlist) => playlist.playlistContent)),
  ];

  return {
    playlists,
    playlistIds,
    savedArticlesIds,
    savedContentIds,
    isLoading: query.state === "pending",
    isFetching: query.isFetching,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
    canFetchNextPage: query.state === "success" && query.canFetchNextPage,
  };
}
